// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Club dialog — modern presentation ─────────────────────────────── */

.club-dlg.MuiDialog-root .MuiDialog-paper,
.club-dlg .MuiDialog-paper {
  border-radius: 20px !important;
  overflow: hidden;
  background: var(--bg-color, #fff);
  color: var(--text-color, #1a1a1a);
  margin: 8px;
  width: calc(100% - 16px) !important;
  max-width: calc(100% - 16px) !important;
  max-height: min(92vh, 900px);
}

.club-dlg--fit.MuiDialog-root .MuiDialog-paper,
.club-dlg--fit .MuiDialog-paper {
  margin: 8px;
  width: calc(100% - 16px);
  max-width: calc(100% - 16px);
  height: calc(100% - 16px);
  max-height: calc(100% - 16px);
  border-radius: 16px !important;
}

.club-dlg--fit.MuiDialog-root .MuiDialog-paper,
.club-dlg--fit .MuiDialog-paper {
  margin: 8px;
  width: calc(100% - 16px);
  max-width: calc(100% - 16px);
  height: calc(100% - 16px);
  max-height: calc(100% - 16px);
  border-radius: 16px !important;
}

@media (max-width: 767px) {
  .club-dlg--fit.MuiDialog-root .MuiDialog-paper,
  .club-dlg--fit .MuiDialog-paper {
    margin: 0;
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0 !important;
  }
}

.club-dlg__presence-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 4px;
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  color: var(--brand-primary, #0877bc);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.club-dlg__presence-btn:hover {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);
}

.club-dlg__hero {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 18px;
  padding: 28px 24px 20px;
  background:
    radial-gradient(
      120% 140% at 0% 0%,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) 0%,
      transparent 55%
    ),
    linear-gradient(
      135deg,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) 0%,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.02) 50%,
      transparent 100%
    ),
    var(--bg-color, #fff);
  border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
}

.club-dlg__hero-close {
  position: absolute !important;
  top: 10px;
  right: 10px;
  color: var(--text-secondary, #666) !important;
}

.club-dlg__logo-wrap {
  position: relative;
  flex-shrink: 0;
  width: 112px;
  height: 112px;
  border-radius: 22px;
  overflow: hidden;
  background: var(--bg-color, #fff);
  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);
  box-shadow: 0 8px 24px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);
  cursor: default;
}

.club-dlg__logo-wrap--clickable {
  cursor: pointer;
  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s ease;
}

.club-dlg__logo-wrap--clickable:hover,
.club-dlg__logo-wrap--editable:hover {
  transform: scale(1.04);
  box-shadow: 0 12px 28px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.32);
}

.club-dlg__logo-wrap--editable {
  cursor: pointer;
  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s ease;
}

.club-dlg__logo-edit {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 5px 6px 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #fff;
  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.62) 40%);
  pointer-events: none;
}

.club-dlg__logo-wrap .club-logo-mark {
  width: 100% !important;
  height: 100% !important;
  border-radius: 18px !important;
  border: none !important;
  object-fit: cover;
}

.club-dlg__logo-spinner {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);
  z-index: 1;
}

.club-dlg__hero-text {
  flex: 1 1;
  min-width: 0;
  padding-bottom: 2px;
}

.club-dlg__club-name {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 750;
  letter-spacing: -0.03em;
  line-height: 1.2;
  color: var(--text-color, #111);
}

.club-dlg__hero-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.club-dlg__stat-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 650;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);
  color: var(--brand-primary, #0877BC);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);
}

.club-dlg__stat-pill--muted {
  background: rgba(0, 0, 0, 0.04);
  color: var(--text-secondary, #666);
  border-color: rgba(0, 0, 0, 0.08);
}

.dark-mode .club-dlg__stat-pill--muted {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.1);
  color: var(--text-secondary, #aaa);
}

/* Tabs */
.club-dlg__tabs {
  min-height: 44px !important;
  padding: 0 12px;
  background: transparent;
}

.club-dlg__tabs .MuiTab-root {
  min-height: 44px;
  text-transform: none;
  font-weight: 650;
  font-size: 0.9rem;
  color: var(--text-secondary, #666);
  opacity: 1;
}

.club-dlg__tabs .MuiTab-root.Mui-selected {
  color: var(--brand-primary, #0877BC);
}

.club-dlg__tabs .MuiTabs-indicator {
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--brand-primary, #0877BC);
}

.club-dlg__body {
  padding: 0 !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.club-dlg__pane {
  padding: 20px 24px 24px;
  overflow-y: auto;
  max-height: min(62vh, 560px);
  animation: clubDlgFade 0.28s ease;
}

@keyframes clubDlgFade {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.club-dlg__section {
  margin-bottom: 22px;
}

.club-dlg__section:last-child {
  margin-bottom: 0;
}

.club-dlg__section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary, #666);
}

.club-dlg__section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.club-dlg__section-head .club-dlg__section-title {
  margin-bottom: 0;
}

.club-dlg__edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
  color: var(--brand-primary, #0877BC);
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 0.75rem;
  font-weight: 650;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.club-dlg__edit-btn:hover {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45);
}

.club-dlg__edit-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.club-dlg__input {
  width: 100%;
  margin-top: 2px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);
  background: var(--surface-color, var(--bg-color, #fff));
  color: var(--text-color, #222);
  font-size: 0.875rem;
  font-weight: 550;
  outline: none;
  box-sizing: border-box;
}

.club-dlg__input:focus {
  border-color: var(--brand-primary, #0877BC);
  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.15);
}

.club-dlg__section-title svg {
  font-size: 18px !important;
  color: var(--brand-primary, #0877BC);
}

/* Info cards */
.club-dlg__info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

@media (max-width: 640px) {
  .club-dlg__info-grid {
    grid-template-columns: 1fr;
  }
}

.club-dlg__card {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  border-radius: 14px;
  padding: 14px 16px;
}

.club-dlg__card-label {
  margin: 0 0 10px;
  font-size: 0.7rem;
  font-weight: 750;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-secondary, #888);
}

.club-dlg__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.club-dlg__row:last-child {
  margin-bottom: 0;
}

.club-dlg__row-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  color: var(--brand-primary, #0877BC);
}

.club-dlg__row-icon svg {
  font-size: 15px !important;
}

.club-dlg__row-body {
  min-width: 0;
  flex: 1 1;
}

.club-dlg__row-key {
  display: block;
  font-size: 0.68rem;
  font-weight: 650;
  color: var(--text-secondary, #888);
  margin-bottom: 1px;
}

.club-dlg__row-val {
  font-size: 0.875rem;
  font-weight: 550;
  color: var(--text-color, #222);
  word-break: break-word;
}

.club-dlg__row-val a {
  color: var(--brand-primary, #0877BC);
  text-decoration: none;
  font-weight: 650;
}

.club-dlg__row-val a:hover {
  text-decoration: underline;
}

/* Committee */
.club-dlg__committee {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.club-dlg__committee-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 14px;
  background: var(--bg-color, #fff);
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.club-dlg__committee-card:hover {
  transform: translateY(-1px);
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
}

.club-dlg__committee-avatar {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 750;
  font-size: 0.85rem;
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877BC),
    var(--brand-primary-light, #0a8cd8)
  );
  box-shadow: 0 4px 10px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);
}

.club-dlg__committee-name {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 650;
  color: var(--text-color, #222);
  line-height: 1.25;
}

.club-dlg__committee-role {
  margin: 2px 0 0;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--brand-primary, #0877BC);
  text-transform: capitalize;
  letter-spacing: 0.01em;
}

/* Training rooms */
.club-dlg__rooms {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.club-dlg__room {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  background: rgba(0, 0, 0, 0.015);
  transition: border-color 0.2s ease, background 0.2s ease;
}

.dark-mode .club-dlg__room {
  background: rgba(255, 255, 255, 0.03);
}

.club-dlg__room:hover {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04);
}

.club-dlg__room-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  color: var(--brand-primary, #0877BC);
}

.club-dlg__room-name {
  margin: 0 0 4px;
  font-size: 0.9rem;
  font-weight: 650;
  color: var(--text-color, #222);
}

.club-dlg__room-addr {
  margin: 0;
  font-size: 0.78rem;
  color: var(--text-secondary, #666);
  line-height: 1.4;
  white-space: pre-line;
}

a.club-dlg__room-addr--maps {
  display: inline-block;
  color: var(--brand-primary, #0877bc);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

a.club-dlg__room-addr--maps:hover,
a.club-dlg__room-addr--maps:focus-visible {
  color: var(--brand-primary-dark, #065a8f);
}

.club-dlg__empty {
  text-align: center;
  padding: 36px 16px;
  color: var(--text-secondary, #888);
}

.club-dlg__empty svg {
  font-size: 40px !important;
  opacity: 0.35;
  margin-bottom: 8px;
}

.club-dlg__map {
  height: 280px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
}

/* ── Members tab — compact ─────────────────────────────────────────── */

.club-dlg__members-pane {
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: min(62vh, 560px);
  overflow: hidden;
  animation: clubDlgFade 0.28s ease;
}

.club-dlg__members-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.club-dlg__search {
  flex: 1 1;
  min-width: 160px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 10px;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);
}

.club-dlg__search svg {
  font-size: 18px !important;
  color: var(--text-secondary, #888);
  flex-shrink: 0;
}

.club-dlg__search input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.85rem;
  color: var(--text-color, #222);
  min-width: 0;
}

.club-dlg__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.club-dlg__filter {
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));
  background: transparent;
  color: var(--text-secondary, #666);
  font-size: 0.72rem;
  font-weight: 650;
  padding: 5px 10px;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.club-dlg__filter:hover {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
  color: var(--brand-primary, #0877BC);
}

.club-dlg__filter--active {
  background: var(--brand-primary, #0877BC);
  border-color: var(--brand-primary, #0877BC);
  color: #fff;
}

.club-dlg__members-count {
  font-size: 0.72rem;
  font-weight: 650;
  color: var(--text-secondary, #888);
  margin-left: auto;
}

.club-dlg__members-list {
  flex: 1 1;
  overflow-y: auto;
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  background: rgba(0, 0, 0, 0.01);
}

.dark-mode .club-dlg__members-list {
  background: rgba(255, 255, 255, 0.02);
}

.club-dlg__members-head {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) 90px 64px 72px 64px;
  gap: 8px;
  padding: 6px 12px;
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  font-size: 0.65rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary, #666);
}

.club-dlg__member-row {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) 90px 64px 72px 64px;
  gap: 8px;
  align-items: center;
  padding: 6px 12px;
  min-height: 40px;
  border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.05));
  transition: background 0.15s ease;
}

.club-dlg__member-row:last-child {
  border-bottom: none;
}

.club-dlg__member-row:hover {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.05);
}

.club-dlg__member-identity {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.club-dlg__member-avatar {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 750;
  color: var(--brand-primary, #0877BC);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
}

.club-dlg__member-name {
  font-size: 0.8125rem;
  font-weight: 650;
  color: var(--text-color, #222);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.club-dlg__member-sub {
  font-size: 0.68rem;
  color: var(--text-secondary, #888);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.club-dlg__member-role {
  font-size: 0.68rem !important;
  height: 22px !important;
  max-width: 100%;
}

.club-dlg__member-role .MuiChip-label {
  padding-left: 6px;
  padding-right: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.club-dlg__classement {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 750;
  color: #fff;
  letter-spacing: 0.02em;
}

.club-dlg__classement--A { background: #2e7d32; }
.club-dlg__classement--B { background: #1565c0; }
.club-dlg__classement--C { background: #ef6c00; }
.club-dlg__classement--D,
.club-dlg__classement--other { background: #c62828; }

.club-dlg__pts {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--brand-primary, #0877BC);
  font-variant-numeric: tabular-nums;
}

.club-dlg__pts--muted,
.club-dlg__dash {
  color: var(--text-secondary, #aaa);
  font-weight: 500;
  font-size: 0.78rem;
}

.club-dlg__status-dot {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.68rem;
  font-weight: 650;
  color: var(--text-secondary, #888);
}

.club-dlg__status-dot::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #9e9e9e;
}

.club-dlg__status-dot--active {
  color: #2e7d32;
}

.club-dlg__status-dot--active::before {
  background: #43a047;
  box-shadow: 0 0 0 3px rgba(67, 160, 71, 0.2);
}

.club-dlg__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 20px !important;
  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08)) !important;
}

.club-dlg__footer-meta {
  font-size: 0.8rem;
  color: var(--text-secondary, #666);
}

.club-dlg__footer-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

@media (max-width: 720px) {
  .club-dlg__hero {
    padding: 22px 16px 16px;
    gap: 14px;
  }

  .club-dlg__logo-wrap {
    width: 68px;
    height: 68px;
    border-radius: 16px;
  }

  .club-dlg__club-name {
    font-size: 1.2rem;
  }

  .club-dlg__pane,
  .club-dlg__members-pane {
    padding-left: 14px;
    padding-right: 14px;
  }

  .club-dlg__members-head,
  .club-dlg__member-row {
    grid-template-columns: minmax(0, 1.4fr) 72px 52px 56px;
  }

  .club-dlg__members-head > :nth-child(5),
  .club-dlg__member-row > :nth-child(5) {
    display: none;
  }
}

@media (max-width: 480px) {
  .club-dlg__members-head,
  .club-dlg__member-row {
    grid-template-columns: minmax(0, 1fr) 48px 52px;
  }

  .club-dlg__members-head > :nth-child(2),
  .club-dlg__member-row > :nth-child(2),
  .club-dlg__members-head > :nth-child(5),
  .club-dlg__member-row > :nth-child(5) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ClubUsersModal.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,iCAAiC;EACjC,iCAAiC;EACjC,WAAW;EACX,mCAAmC;EACnC,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE;;IAEE,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mEAAmE;EACnE,6DAA6D;EAC7D,oCAAoC;EACpC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB;;;;;;;;;;;;yBAYuB;EACvB,iEAAiE;AACnE;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,mEAAmE;EACnE,uEAAuE;EACvE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gFAAgF;AAClF;;AAEA;;EAEE,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,4EAA4E;EAC5E,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,4DAA4D;EAC5D,oCAAoC;EACpC,mEAAmE;AACrE;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,SAAS;AACT;EACE,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mEAAmE;EACnE,6DAA6D;EAC7D,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,6DAA6D;EAC7D,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mEAAmE;EACnE,uDAAuD;EACvD,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,uEAAuE;AACzE;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,6DAA6D;EAC7D,mEAAmE;EACnE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6DAA6D;EAC7D,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,0DAA0D;EAC1D,yCAAyC;EACzC,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,+DAA+D;EAC/D,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX;;;;GAIC;EACD,uEAAuE;AACzE;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;EAC1D,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+DAA+D;EAC/D,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6DAA6D;EAC7D,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA,yEAAyE;;AAEzE;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;EAC7D,mEAAmE;AACrE;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,0DAA0D;EAC1D,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,+DAA+D;EAC/D,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,0DAA0D;EAC1D,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6DAA6D;EAC7D,0BAA0B;EAC1B,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iEAAiE;EACjE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,2BAA2B,mBAAmB,EAAE;AAChD,2BAA2B,mBAAmB,EAAE;AAChD,2BAA2B,mBAAmB,EAAE;AAChD;+BAC+B,mBAAmB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,yEAAyE;AAC3E;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,sDAAsD;EACxD;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,+CAA+C;EACjD;;EAEA;;;;IAIE,aAAa;EACf;AACF","sourcesContent":["/* ── Club dialog — modern presentation ─────────────────────────────── */\n\n.club-dlg.MuiDialog-root .MuiDialog-paper,\n.club-dlg .MuiDialog-paper {\n  border-radius: 20px !important;\n  overflow: hidden;\n  background: var(--bg-color, #fff);\n  color: var(--text-color, #1a1a1a);\n  margin: 8px;\n  width: calc(100% - 16px) !important;\n  max-width: calc(100% - 16px) !important;\n  max-height: min(92vh, 900px);\n}\n\n.club-dlg--fit.MuiDialog-root .MuiDialog-paper,\n.club-dlg--fit .MuiDialog-paper {\n  margin: 8px;\n  width: calc(100% - 16px);\n  max-width: calc(100% - 16px);\n  height: calc(100% - 16px);\n  max-height: calc(100% - 16px);\n  border-radius: 16px !important;\n}\n\n.club-dlg--fit.MuiDialog-root .MuiDialog-paper,\n.club-dlg--fit .MuiDialog-paper {\n  margin: 8px;\n  width: calc(100% - 16px);\n  max-width: calc(100% - 16px);\n  height: calc(100% - 16px);\n  max-height: calc(100% - 16px);\n  border-radius: 16px !important;\n}\n\n@media (max-width: 767px) {\n  .club-dlg--fit.MuiDialog-root .MuiDialog-paper,\n  .club-dlg--fit .MuiDialog-paper {\n    margin: 0;\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: 100%;\n    border-radius: 0 !important;\n  }\n}\n\n.club-dlg__presence-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 4px;\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  color: var(--brand-primary, #0877bc);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.club-dlg__presence-btn:hover {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);\n}\n\n.club-dlg__hero {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  gap: 18px;\n  padding: 28px 24px 20px;\n  background:\n    radial-gradient(\n      120% 140% at 0% 0%,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) 0%,\n      transparent 55%\n    ),\n    linear-gradient(\n      135deg,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) 0%,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.02) 50%,\n      transparent 100%\n    ),\n    var(--bg-color, #fff);\n  border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n}\n\n.club-dlg__hero-close {\n  position: absolute !important;\n  top: 10px;\n  right: 10px;\n  color: var(--text-secondary, #666) !important;\n}\n\n.club-dlg__logo-wrap {\n  position: relative;\n  flex-shrink: 0;\n  width: 112px;\n  height: 112px;\n  border-radius: 22px;\n  overflow: hidden;\n  background: var(--bg-color, #fff);\n  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);\n  box-shadow: 0 8px 24px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);\n  cursor: default;\n}\n\n.club-dlg__logo-wrap--clickable {\n  cursor: pointer;\n  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s ease;\n}\n\n.club-dlg__logo-wrap--clickable:hover,\n.club-dlg__logo-wrap--editable:hover {\n  transform: scale(1.04);\n  box-shadow: 0 12px 28px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.32);\n}\n\n.club-dlg__logo-wrap--editable {\n  cursor: pointer;\n  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s ease;\n}\n\n.club-dlg__logo-edit {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 5px 6px 6px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  color: #fff;\n  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.62) 40%);\n  pointer-events: none;\n}\n\n.club-dlg__logo-wrap .club-logo-mark {\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 18px !important;\n  border: none !important;\n  object-fit: cover;\n}\n\n.club-dlg__logo-spinner {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);\n  z-index: 1;\n}\n\n.club-dlg__hero-text {\n  flex: 1;\n  min-width: 0;\n  padding-bottom: 2px;\n}\n\n.club-dlg__club-name {\n  margin: 0;\n  font-size: 1.45rem;\n  font-weight: 750;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n  color: var(--text-color, #111);\n}\n\n.club-dlg__hero-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.club-dlg__stat-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 650;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);\n  color: var(--brand-primary, #0877BC);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);\n}\n\n.club-dlg__stat-pill--muted {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--text-secondary, #666);\n  border-color: rgba(0, 0, 0, 0.08);\n}\n\n.dark-mode .club-dlg__stat-pill--muted {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: var(--text-secondary, #aaa);\n}\n\n/* Tabs */\n.club-dlg__tabs {\n  min-height: 44px !important;\n  padding: 0 12px;\n  background: transparent;\n}\n\n.club-dlg__tabs .MuiTab-root {\n  min-height: 44px;\n  text-transform: none;\n  font-weight: 650;\n  font-size: 0.9rem;\n  color: var(--text-secondary, #666);\n  opacity: 1;\n}\n\n.club-dlg__tabs .MuiTab-root.Mui-selected {\n  color: var(--brand-primary, #0877BC);\n}\n\n.club-dlg__tabs .MuiTabs-indicator {\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: var(--brand-primary, #0877BC);\n}\n\n.club-dlg__body {\n  padding: 0 !important;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.club-dlg__pane {\n  padding: 20px 24px 24px;\n  overflow-y: auto;\n  max-height: min(62vh, 560px);\n  animation: clubDlgFade 0.28s ease;\n}\n\n@keyframes clubDlgFade {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.club-dlg__section {\n  margin-bottom: 22px;\n}\n\n.club-dlg__section:last-child {\n  margin-bottom: 0;\n}\n\n.club-dlg__section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  font-size: 0.72rem;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #666);\n}\n\n.club-dlg__section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.club-dlg__section-head .club-dlg__section-title {\n  margin-bottom: 0;\n}\n\n.club-dlg__edit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n  color: var(--brand-primary, #0877BC);\n  border-radius: 8px;\n  padding: 5px 10px;\n  font-size: 0.75rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.club-dlg__edit-btn:hover {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45);\n}\n\n.club-dlg__edit-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.club-dlg__input {\n  width: 100%;\n  margin-top: 2px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);\n  background: var(--surface-color, var(--bg-color, #fff));\n  color: var(--text-color, #222);\n  font-size: 0.875rem;\n  font-weight: 550;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.club-dlg__input:focus {\n  border-color: var(--brand-primary, #0877BC);\n  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.15);\n}\n\n.club-dlg__section-title svg {\n  font-size: 18px !important;\n  color: var(--brand-primary, #0877BC);\n}\n\n/* Info cards */\n.club-dlg__info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 640px) {\n  .club-dlg__info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.club-dlg__card {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  border-radius: 14px;\n  padding: 14px 16px;\n}\n\n.club-dlg__card-label {\n  margin: 0 0 10px;\n  font-size: 0.7rem;\n  font-weight: 750;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #888);\n}\n\n.club-dlg__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.club-dlg__row:last-child {\n  margin-bottom: 0;\n}\n\n.club-dlg__row-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  color: var(--brand-primary, #0877BC);\n}\n\n.club-dlg__row-icon svg {\n  font-size: 15px !important;\n}\n\n.club-dlg__row-body {\n  min-width: 0;\n  flex: 1;\n}\n\n.club-dlg__row-key {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 650;\n  color: var(--text-secondary, #888);\n  margin-bottom: 1px;\n}\n\n.club-dlg__row-val {\n  font-size: 0.875rem;\n  font-weight: 550;\n  color: var(--text-color, #222);\n  word-break: break-word;\n}\n\n.club-dlg__row-val a {\n  color: var(--brand-primary, #0877BC);\n  text-decoration: none;\n  font-weight: 650;\n}\n\n.club-dlg__row-val a:hover {\n  text-decoration: underline;\n}\n\n/* Committee */\n.club-dlg__committee {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 10px;\n}\n\n.club-dlg__committee-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: var(--bg-color, #fff);\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.club-dlg__committee-card:hover {\n  transform: translateY(-1px);\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n}\n\n.club-dlg__committee-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 750;\n  font-size: 0.85rem;\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877BC),\n    var(--brand-primary-light, #0a8cd8)\n  );\n  box-shadow: 0 4px 10px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);\n}\n\n.club-dlg__committee-name {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 650;\n  color: var(--text-color, #222);\n  line-height: 1.25;\n}\n\n.club-dlg__committee-role {\n  margin: 2px 0 0;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--brand-primary, #0877BC);\n  text-transform: capitalize;\n  letter-spacing: 0.01em;\n}\n\n/* Training rooms */\n.club-dlg__rooms {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.club-dlg__room {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  background: rgba(0, 0, 0, 0.015);\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.dark-mode .club-dlg__room {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.club-dlg__room:hover {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04);\n}\n\n.club-dlg__room-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  color: var(--brand-primary, #0877BC);\n}\n\n.club-dlg__room-name {\n  margin: 0 0 4px;\n  font-size: 0.9rem;\n  font-weight: 650;\n  color: var(--text-color, #222);\n}\n\n.club-dlg__room-addr {\n  margin: 0;\n  font-size: 0.78rem;\n  color: var(--text-secondary, #666);\n  line-height: 1.4;\n  white-space: pre-line;\n}\n\na.club-dlg__room-addr--maps {\n  display: inline-block;\n  color: var(--brand-primary, #0877bc);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n\na.club-dlg__room-addr--maps:hover,\na.club-dlg__room-addr--maps:focus-visible {\n  color: var(--brand-primary-dark, #065a8f);\n}\n\n.club-dlg__empty {\n  text-align: center;\n  padding: 36px 16px;\n  color: var(--text-secondary, #888);\n}\n\n.club-dlg__empty svg {\n  font-size: 40px !important;\n  opacity: 0.35;\n  margin-bottom: 8px;\n}\n\n.club-dlg__map {\n  height: 280px;\n  border-radius: 14px;\n  overflow: hidden;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n}\n\n/* ── Members tab — compact ─────────────────────────────────────────── */\n\n.club-dlg__members-pane {\n  padding: 12px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: min(62vh, 560px);\n  overflow: hidden;\n  animation: clubDlgFade 0.28s ease;\n}\n\n.club-dlg__members-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.club-dlg__search {\n  flex: 1;\n  min-width: 160px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-radius: 10px;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);\n}\n\n.club-dlg__search svg {\n  font-size: 18px !important;\n  color: var(--text-secondary, #888);\n  flex-shrink: 0;\n}\n\n.club-dlg__search input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 0.85rem;\n  color: var(--text-color, #222);\n  min-width: 0;\n}\n\n.club-dlg__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.club-dlg__filter {\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));\n  background: transparent;\n  color: var(--text-secondary, #666);\n  font-size: 0.72rem;\n  font-weight: 650;\n  padding: 5px 10px;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.club-dlg__filter:hover {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n  color: var(--brand-primary, #0877BC);\n}\n\n.club-dlg__filter--active {\n  background: var(--brand-primary, #0877BC);\n  border-color: var(--brand-primary, #0877BC);\n  color: #fff;\n}\n\n.club-dlg__members-count {\n  font-size: 0.72rem;\n  font-weight: 650;\n  color: var(--text-secondary, #888);\n  margin-left: auto;\n}\n\n.club-dlg__members-list {\n  flex: 1;\n  overflow-y: auto;\n  border-radius: 12px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  background: rgba(0, 0, 0, 0.01);\n}\n\n.dark-mode .club-dlg__members-list {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.club-dlg__members-head {\n  display: grid;\n  grid-template-columns: minmax(0, 1.6fr) 90px 64px 72px 64px;\n  gap: 8px;\n  padding: 6px 12px;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  font-size: 0.65rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #666);\n}\n\n.club-dlg__member-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.6fr) 90px 64px 72px 64px;\n  gap: 8px;\n  align-items: center;\n  padding: 6px 12px;\n  min-height: 40px;\n  border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.05));\n  transition: background 0.15s ease;\n}\n\n.club-dlg__member-row:last-child {\n  border-bottom: none;\n}\n\n.club-dlg__member-row:hover {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.05);\n}\n\n.club-dlg__member-identity {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.club-dlg__member-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n  font-weight: 750;\n  color: var(--brand-primary, #0877BC);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n}\n\n.club-dlg__member-name {\n  font-size: 0.8125rem;\n  font-weight: 650;\n  color: var(--text-color, #222);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n}\n\n.club-dlg__member-sub {\n  font-size: 0.68rem;\n  color: var(--text-secondary, #888);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n}\n\n.club-dlg__member-role {\n  font-size: 0.68rem !important;\n  height: 22px !important;\n  max-width: 100%;\n}\n\n.club-dlg__member-role .MuiChip-label {\n  padding-left: 6px;\n  padding-right: 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.club-dlg__classement {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  padding: 2px 6px;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 750;\n  color: #fff;\n  letter-spacing: 0.02em;\n}\n\n.club-dlg__classement--A { background: #2e7d32; }\n.club-dlg__classement--B { background: #1565c0; }\n.club-dlg__classement--C { background: #ef6c00; }\n.club-dlg__classement--D,\n.club-dlg__classement--other { background: #c62828; }\n\n.club-dlg__pts {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--brand-primary, #0877BC);\n  font-variant-numeric: tabular-nums;\n}\n\n.club-dlg__pts--muted,\n.club-dlg__dash {\n  color: var(--text-secondary, #aaa);\n  font-weight: 500;\n  font-size: 0.78rem;\n}\n\n.club-dlg__status-dot {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.68rem;\n  font-weight: 650;\n  color: var(--text-secondary, #888);\n}\n\n.club-dlg__status-dot::before {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #9e9e9e;\n}\n\n.club-dlg__status-dot--active {\n  color: #2e7d32;\n}\n\n.club-dlg__status-dot--active::before {\n  background: #43a047;\n  box-shadow: 0 0 0 3px rgba(67, 160, 71, 0.2);\n}\n\n.club-dlg__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 20px !important;\n  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08)) !important;\n}\n\n.club-dlg__footer-meta {\n  font-size: 0.8rem;\n  color: var(--text-secondary, #666);\n}\n\n.club-dlg__footer-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 720px) {\n  .club-dlg__hero {\n    padding: 22px 16px 16px;\n    gap: 14px;\n  }\n\n  .club-dlg__logo-wrap {\n    width: 68px;\n    height: 68px;\n    border-radius: 16px;\n  }\n\n  .club-dlg__club-name {\n    font-size: 1.2rem;\n  }\n\n  .club-dlg__pane,\n  .club-dlg__members-pane {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .club-dlg__members-head,\n  .club-dlg__member-row {\n    grid-template-columns: minmax(0, 1.4fr) 72px 52px 56px;\n  }\n\n  .club-dlg__members-head > :nth-child(5),\n  .club-dlg__member-row > :nth-child(5) {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .club-dlg__members-head,\n  .club-dlg__member-row {\n    grid-template-columns: minmax(0, 1fr) 48px 52px;\n  }\n\n  .club-dlg__members-head > :nth-child(2),\n  .club-dlg__member-row > :nth-child(2),\n  .club-dlg__members-head > :nth-child(5),\n  .club-dlg__member-row > :nth-child(5) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
